import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";

import ServiceCard from "./ServiceCard";

const servicesData = [
  {
    id: "cloud",
    title: "Cloud Solutions",
    description:
      "Providing scalable and secure cloud-based services for storage and computing.",
    imageUrl: "/service-cloud.png",
  },
  {
    id: "custom",
    title: "Custom Software development",
    description:
      "Your Business Has Specific Needs - We Build Specific Solutions.",
    imageUrl: "/service-custom.png",
  },
  {
    id: "web",
    title: "Web Development",
    description: "If Google Can't Find You, Neither Can Your Customers.",
    imageUrl: "/service-web.png",
  },
  {
    id: "ai",
    title: "AI Models Development and Automation",
    description: "Stop Doing Manual Work - Your Smart AI Workforce Is Ready.",
    imageUrl: "/service-ai.png",
  },
  {
    id: "mobile",
    title: "Mobile App Development",
    description: "Your Brand in Every Customer's Pocket.",
    imageUrl: "/service-mobile.png",
  },
  {
    id: "blockchain",
    title: "Blockchain",
    description:
      "Developing forward-thinking blockchain solutions for enhanced security and transparency.",
    imageUrl: "/service-blockchain.png",
  },
  {
    id: "saas",
    title: "SaaS",
    description:
      "Delivering software applications over the cloud with maximum accessibility.",
    imageUrl: "/service-saas.png",
  },
];

const Services = () => {
  const initialSlideIndex = 3;
  return (
    <section
      id="services"
      className="min-h-[90vh] bg-gradient-to-br from-[#C3367C] to-[#4F699B] py-8 md:py-16"
    >
      <div className="flex justify-center mx-4">
        <div className="mb-10 max-w-4xl w-full flex flex-col items-center justify-center text-center">
          <h2 className="mb-4 text-3xl md:text-4xl font-bold text-white">
            Our services
          </h2>
          <p className="text-base md:text-lg text-gray-300">
            We offer end-to-end development, design and consulting for a wide
            range of technologies and industry.
          </p>
        </div>
      </div>

      <div className="relative w-full flex items-center justify-center">
        <div className="relative w-[90%] md:w-full md:px-10 pt-2 pb-16 md:pb-4">
          <Swiper
            modules={[EffectCoverflow, Pagination, Navigation]}
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            loop={true}
            slidesPerView={"auto"}
            direction="horizontal"
            initialSlide={initialSlideIndex}
            coverflowEffect={{
              rotate: 0,
              stretch: 20,
              depth: 120,
              modifier: 1.2,
              slideShadows: true,
            }}
            pagination={{
              clickable: true,
            }}
            navigation={{
              nextEl: ".swiper-button-next-custom",
              prevEl: ".swiper-button-prev-custom",
            }}
            className="services-swiper md:!ml-[5%]"
          >
            {servicesData.map((service) => (
              <SwiperSlide
                key={service.id}
                className="!w-[150px] sm:!w-[180px] md:!w-[200px] lg:!w-[235px] flex justify-center items-center"
              >
                <ServiceCard
                  title={service.title}
                  description={service.description}
                  imageUrl={service.imageUrl}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <button className="hidden md:block swiper-button-prev-custom absolute top-1/2 left-2 md:left-4 lg:left-10 transform -translate-y-1/2 z-20 p-2 bg-white/50 hover:bg-white/80 rounded-full text-gray-800 transition-colors duration-200">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 19.5 8.25 12l7.5-7.5"
            />
          </svg>
        </button>
        <button className="hidden md:block swiper-button-next-custom absolute top-1/2 right-2 md:right-4 lg:right-10 transform -translate-y-1/2 z-20 p-2 bg-white/50 hover:bg-white/80 rounded-full text-gray-800 transition-colors duration-200">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m8.25 4.5 7.5 7.5-7.5 7.5"
            />
          </svg>
        </button>
      </div>
    </section>
  );
};

export default Services;
